import axios from 'axios';

const api = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? `${window.location.origin}/api/v1` : "/api/v1",
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
    },
    timeout: 60000
})


// api.interceptors.response.use(response => response, error => {
//         if (error.response && error.response.status === 401) {
//             localStorage.clear();
//             window.location.reload();
//             return;
//         }
//         return Promise.reject(error);
//     }
// );

export default api;